import React from 'react';
interface QuotationTermsProps {
  termsAndConditions: string;
  additionalNotes?: string;
}
export function QuotationTerms({
  termsAndConditions,
  additionalNotes
}: QuotationTermsProps) {
  return <div className="space-y-5 mb-6" data-id="element-952">
      {/* Terms & Conditions */}
      <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-5" data-id="element-953">
        <h3 className="text-xs font-bold text-neutral-900 uppercase tracking-wide mb-3" data-id="element-954">
          Terms & Conditions
        </h3>
        <div className="text-xs text-neutral-700 leading-relaxed whitespace-pre-line" data-id="element-955">
          {termsAndConditions}
        </div>
      </div>

      {/* Additional Notes */}
      {additionalNotes && <div className="bg-blue-50/50 border border-blue-200 rounded-lg p-5" data-id="element-956">
          <h3 className="text-xs font-bold text-neutral-900 uppercase tracking-wide mb-3" data-id="element-957">
            Additional Notes
          </h3>
          <div className="text-xs text-neutral-700 leading-relaxed whitespace-pre-line" data-id="element-958">
            {additionalNotes}
          </div>
        </div>}
    </div>;
}